module.exports = __webpack_public_path__ + "media/images/alluminium-3-3cd8fd4588e5ace48edb3691c2bcd7b4.jpg";